import colors from '@general/colors';
import fonts from '@general/fonts';
import React from 'react';

export default function TabCountChip({ children }) {
    return (
        <span
            style={{
                padding: 8,
                backgroundColor: colors.primary,
                color: colors.white,
                fontFamily: fonts.sans,
                fontSize: 12,
                borderRadius: '50%',
                marginLeft: '0.5rem',
                height: 22,
                width: 22,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {children}
        </span>
    );
}
